<div class="satellite-images-page">
  <div class="page-content">
    <div class="map-section">
      <app-openstreetmap
        #openstreetmapComponent
        [mapController$]="mapController$"
        [mapOptions]="mapOptions"
        [style.display]="activeTab === 'uploaded' ? 'none' : null">
      </app-openstreetmap>
      <app-uploaded-geo-images-map
        *ngIf="uploadedTabVisited"
        [visible]="activeTab === 'uploaded'"
        [style.display]="activeTab === 'uploaded' ? 'block' : 'none'">
      </app-uploaded-geo-images-map>
    </div>

    <div class="images-section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <button class="back-btn" (click)="goBack()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <h2 class="section-title">{{ 'Satellite Images' | translate }}</h2>
        </div>
        <div class="section-actions">
          <app-primary-button
            title="Upload"
            icon="pi pi-plus"
            (action)="openUploadModal()"
          ></app-primary-button>
        </div>
      </div>

      <div class="filters-bar">
        <app-data-source-switcher
          [activeTab]="activeTab"
          (tabChange)="onTabChange($event)">
        </app-data-source-switcher>
      </div>

      <div class="images-list" *ngIf="activeTab === 'satellites'">
        <!-- Стандартный лоадер как на других страницах -->
        <div class="loading" *ngIf="isLoadingProducts">
          <div class="loading-content">
            <div class="spinner"></div>
            <p>{{ 'Загрузка...' | translate }}</p>
          </div>
        </div>

        <!-- Карточки скрываются во время загрузки -->
        <ng-container *ngIf="!isLoadingProducts">
          <div class="image-item"
               *ngFor="let image of satelliteImages"
               [class.active]="isProductActive(image.apiProductId)"
               (click)="onProductClick(image)"
               style="cursor: pointer;">
          <div class="image-thumbnail">
            <img [src]="image.thumbnail || 'assets/icons/main/light/Group 6.svg'"
                 [alt]="image.name || 'Satellite Image'"
                 (error)="image.thumbnail = 'assets/icons/main/light/Group 6.svg'">
            <div class="image-type" [class]="getSatelliteTypeClass(image.mission)">
              {{ getSatelliteTypeShort(image.mission) }}
            </div>
          </div>

          <div class="image-info">
            <div class="image-name">{{ image.name }}</div>
            <div class="image-details">
              <span class="detail-label">{{ 'Satellite' | translate }}:</span> {{ image.mission }} ({{ image.instrument }})
            </div>
            <div class="image-details">
              <span class="detail-label">{{ 'Sensing time' | translate }}:</span> {{ image.originDate | date:'dd.MM.yy HH:mm'  }}
            </div>
            <div class="image-details">
              <span class="detail-label">{{ 'Upload Date' | translate }}:</span> {{ image.createAt | date:'dd.MM.yy HH:mm' }}
            </div>
            
            <div class="image-details" *ngIf="image?.center">
              <span class="detail-label">{{ 'Coordinates' | translate }}</span>
              {{ image.center.latitude | number:'1.4-4' }},
              {{ image.center.longitude | number:'1.4-4' }}
            </div>
            <div class="image-details" *ngIf="image?.size">
                <span class="detail-label">{{ 'Size' | translate }}</span>
                {{ image.size }} {{ image.unit }}
            </div>
            <div class="image-details" *ngIf="image.cloudCover !== null && image.cloudCover !== undefined">
                <span class="detail-label">{{ 'CLOUD_COVER' | translate }}</span>
                {{ image.cloudCover | number:'1.2-2' }} %
            </div>
            <div class="image-areas" *ngIf="getRegionNamesByIds(image.areas) as allAreaNames">
              <span class="detail-label">{{ 'District' | translate }}:</span>
              <ul class="areas-list">
                <li *ngFor="let areaName of allAreaNames | slice:0:4">{{ areaName }}</li>
              </ul>
              <app-status-tag
                *ngIf="allAreaNames.length > 4"
                class="compact more-regions-tag"
                color="#71717A"
                [label]="'+ ' + (allAreaNames.length - 4)"
                [attr.title]="allAreaNames.join(', ')">
              </app-status-tag>
            </div>
            <!-- Теги бейджами -->
            <div class="image-tags" *ngIf="image.tags && image.tags.length > 0">
              <div class="tags-badges">
                <span class="tag-badge" *ngFor="let tag of image.tags">
                  {{ tag.name }}
                </span>
              </div>
            </div>

          </div>

          <div class="image-actions">
            <button class="icon-btn" [disabled]="!image.mediadataPath" (click)="downloadImage(image); $event.stopPropagation()" [title]="(image.mediadataPath ? 'Download' : 'SATELLITE_ARCHIVE_NOT_DOWNLOADED') | translate">
              <img [src]="isDarkMode ? 'assets/icons/main/dark/map-download.svg' : 'assets/icons/main/light/map-download.svg'" [alt]="'Download' | translate">
            </button>
            <!-- <button class="icon-btn" (click)="viewImageDetails(image, $event); $event.stopPropagation()" [title]="'Details' | translate">
              <img [src]="isDarkMode ? 'assets/icons/main/dark/full-screen-btn.svg' : 'assets/icons/main/light/full-screen-btn.svg'" [alt]="'Details' | translate">
            </button> -->
            <button class="icon-btn" (click)="openTagModal(image); $event.stopPropagation()" [title]="'Tags' | translate">
              <img [src]="isDarkMode ? 'assets/icons/main/dark/ico-btn-edit.svg' : 'assets/icons/main/light/ico-btn-edit.svg'" [alt]="'Tags' | translate">
            </button>
          </div>
        </div>
        </ng-container>
      </div>

      <div class="requests-table-wrapper" *ngIf="activeTab === 'requests'">
        <div class="task-status-table" *ngIf="!taskStatusLoading && taskStatusData.length > 0">
          <table class="status-table">
            <thead>
              <tr>
                <th class="col-date">{{ 'Дата заявки' | translate }}</th>
                <th class="col-satellite">{{ 'Спутник' | translate }}</th>
                <th class="col-region">{{ 'Регион' | translate }}</th>
                <th class="col-origin">{{ 'Дата съемки' | translate }}</th>
                <th class="col-status">{{ 'Статус' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let task of taskStatusData" (click)="onTaskRowClick(task)" class="task-row">
                <td class="col-date">
                  <div class="date-cell">{{ formatDate(task.createAt) }}</div>
                </td>
                <td class="col-satellite">
                  <div class="satellite-cell">{{ getSatelliteName(task.satelliteType) }}</div>
                </td>
                <td class="col-region">
                  <div class="region-cell">{{ task.regionName || '—' }}</div>
                </td>
                <td class="col-origin">
                  <div class="date-cell">{{ task.originDate ? formatDate(task.originDate) : '—' }}</div>
                </td>
                <td class="col-status">
                  <div class="status-container">
                    <span class="status-badge" [class]="getTaskStatusClass(task.status)">
                      {{ task.statusName }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="no-data" *ngIf="!taskStatusLoading && taskStatusData.length === 0">
          <div class="no-data-content">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <path d="M24 4C12.96 4 4 12.96 4 24s8.96 20 20 20 20-8.96 20-20S35.04 4 24 4zm0 36c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z" fill="currentColor"/>
              <path d="M24 12c-6.63 0-12 5.37-12 12s5.37 12 12 12 12-5.37 12-12-5.37-12-12-12zm0 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" fill="currentColor"/>
            </svg>
            <p>{{ 'Нет задач для отображения' | translate }}</p>
          </div>
        </div>

        <div class="loading" *ngIf="taskStatusLoading">
          <div class="loading-content">
            <div class="spinner"></div>
            <p>{{ 'Загрузка...' | translate }}</p>
          </div>
        </div>

        <!-- Пагинация для таблицы заявок -->
        <div class="pagination-container" *ngIf="activeTab === 'requests' && totalPages > 1">
          <div class="pagination-controls">
            <!-- Кнопка "Предыдущая" -->
            <button
              class="pagination-btn prev-btn"
              [disabled]="currentPage === 1 || taskStatusLoading"
              (click)="onPageChange(currentPage - 1)"
              [class.disabled]="currentPage === 1 || taskStatusLoading">
              <svg *ngIf="!taskStatusLoading" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div *ngIf="taskStatusLoading" class="loading-spinner"></div>
            </button>

            <!-- Информация о странице -->
            <div class="page-info">
              <span class="current-page">{{ currentPage }}</span>
              <span class="page-separator">{{ 'из' | translate }}</span>
              <span class="total-pages">{{ totalPages }}</span>
            </div>

            <!-- Кнопка "Следующая" -->
            <button
              class="pagination-btn next-btn"
              [disabled]="currentPage === totalPages || taskStatusLoading"
              (click)="onPageChange(currentPage + 1)"
              [class.disabled]="currentPage === totalPages || taskStatusLoading">
              <svg *ngIf="!taskStatusLoading" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div *ngIf="taskStatusLoading" class="loading-spinner"></div>
            </button>
          </div>
        </div>
      </div>

      <div class="images-list" *ngIf="activeTab === 'uploaded'">
        <app-uploaded-geo-images></app-uploaded-geo-images>
      </div>

      <div class="results-info" *ngIf="activeTab === 'satellites'">
        <!-- Пагинация -->
        <div class="pagination-container" *ngIf="totalPages > 1">
          <div class="pagination-controls">
            <!-- Кнопка "Предыдущая" -->
            <button
              class="pagination-btn prev-btn"
              [disabled]="currentPage === 1"
              (click)="onPageChange(currentPage - 1)"
              [class.disabled]="currentPage === 1">
              <img src="assets/icons/main/light/paginator-left-icon.svg" alt="Previous">
            </button>

            <!-- Информация о странице -->
            <div class="page-info">
              <span class="current-page">{{ currentPage }}</span>
              <span class="page-separator">{{ 'из' | translate }}</span>
              <span class="total-pages">{{ totalPages }}</span>
            </div>

            <!-- Кнопка "Следующая" -->
            <button
              class="pagination-btn next-btn"
              [disabled]="currentPage === totalPages"
              (click)="onPageChange(currentPage + 1)"
              [class.disabled]="currentPage === totalPages">
              <img src="assets/icons/main/light/paginator-right-icon.svg" alt="Next">
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="filters-sidebar" [class.collapsed]="!filtersVisible">
      <div class="filters-header">
        <h3>{{ 'FILTERS' | translate }}</h3>
        <button class="toggle-filters-btn" (click)="toggleFilters()" [attr.aria-label]="filtersVisible ? ('tile_map.buttons.hide_filters' | translate) : ('tile_map.buttons.show_filters' | translate)">
          <img [src]="filtersVisible ? 'assets/icons/main/light/ico-side-menu-trigger-off.svg' : 'assets/icons/main/light/ico-side-menu-trigger-on.svg'"
               [alt]="filtersVisible ? 'Скрыть' : 'Показать'">
        </button>
      </div>

      <div class="filters-content" *ngIf="filtersVisible && activeTab === 'uploaded'">
        <app-geo-image-filters></app-geo-image-filters>
      </div>

      <div class="filters-content" *ngIf="filtersVisible && activeTab !== 'uploaded'">
        <div class="filter-section">
          <label>{{ 'Region' | translate }}</label>
          <msf-tree-select
            [(model)]="selectedRegionId"
            [service]="regionManagementManager"
            serviceMethod="getRegionsObservable"
            [placeholder]="'Select Region' | translate"
            [showClear]="true"
            [treeBy]="'parentId'"
            (modelChange)="onRegionSelected($event)"
          />
        </div>

        <div class="filter-section">
          <label>{{ 'DATA_SOURCE' | translate }}</label>
          <div class="dropdown-selector data-source-selector">
            <div class="selector-button" (click)="toggleDataSourceDropdown($event)">
              <span>{{ getDisplayDataSourceLabel() }}</span>
              <i class="pi pi-chevron-down"></i>
            </div>

            <div class="dropdown-menu" *ngIf="showDataSourceDropdown" (click)="$event.stopPropagation()">
              <div class="dropdown-list">
                <div
                  class="dropdown-item"
                  *ngFor="let option of satelliteOptions"
                  [class.selected]="selectedDataSource === option.value"
                  (click)="selectDataSourceOption(option, $event)">
                  {{ option.labelKey | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-section">
          <label>{{ 'Период' | translate }}</label>
          <div class="period-range">
                <app-date-picker
                  [(ngModel)]="selectedStartDate"
                  [placeholder]="'Начало' | translate"
                  [showIcon]="true"
                  [dateFormat]="'dd.mm.yy'"
                  [maxDate]="selectedEndDate">
                </app-date-picker>
                <app-date-picker
                  [(ngModel)]="selectedEndDate"
                  [placeholder]="'Конец' | translate"
                  [showIcon]="true"
                  [dateFormat]="'dd.mm.yy'"
                  [minDate]="selectedStartDate">
                </app-date-picker>
          </div>
        </div>

        <div class="filter-section cloud-cover-filter">
          <label for="satellite-images-max-cloud-cover">{{ 'MAX_CLOUD_COVER' | translate }}</label>
          <div class="cloud-cover-control">
            <input
              id="satellite-images-max-cloud-cover"
              class="cloud-cover-slider"
              type="range"
              min="0"
              max="100"
              step="5"
              [(ngModel)]="selectedMaxCloudCover"
              (ngModelChange)="onMaxCloudCoverChange($event)" />
            <span class="cloud-cover-value">{{ selectedMaxCloudCover }}%</span>
          </div>
        </div>

        <div class="filter-section">
          <label>{{ 'Теги' | translate }}</label>
          <div class="dropdown-selector tag-selector">
            <div class="selector-button" (click)="toggleTagDropdown($event)">
              <span>{{ getDisplayTagLabel() }}</span>
              <i class="pi pi-chevron-down"></i>
            </div>

            <div class="dropdown-menu" *ngIf="showTagDropdown" (click)="$event.stopPropagation()">
              <div class="dropdown-search">
                <input
                  type="text"
                  [(ngModel)]="tagSearchText"
                  [placeholder]="'SEARCH' | translate"
                  class="dropdown-search-input">
              </div>

              <div class="dropdown-list">
                <div
                  class="dropdown-item"
                  *ngFor="let tag of filteredTagOptions"
                  [class.selected]="(!selectedTag && tag.value === '') || selectedTag === tag.value"
                  (click)="selectTagOption(tag, $event)">
                  {{ tag.label }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-actions">
          <app-primary-button
            style="width: 100%;"
            title="Apply"
            (action)="applyFilters()"
          ></app-primary-button>
        </div>

        <!-- Плашка "Данные обновлены" рядом с кнопкой Применить -->
        <div class="data-updated-banner" *ngIf="lastUpdatedAt">
          {{ 'Data updated' | translate }} {{ lastUpdatedAt | date:'dd.MM.yyyy HH:mm' }}
        </div>
      </div>

      <div class="export-section" *ngIf="filtersVisible && activeTab !== 'uploaded'">
        <app-secondary-button
          title="Reset filter"
          (action)="resetFilters()"
        ></app-secondary-button>
      </div>

      <!-- Найдено результатов -->
      <div class="results-count" *ngIf="activeTab === 'satellites' && filtersVisible">
        {{ totalResultsText }}
      </div>
    </div>
  </div>

  <!-- Tag Modal -->
  <div class="modal-overlay" *ngIf="showTagModal" (click)="closeTagModal()">
    <div class="modal-content tag-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'SATELLITE_IMAGES.EDIT_MODAL.TITLE' | translate }}</h3>
        <button class="close-btn" (click)="closeTagModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <!-- Нередактируемые данные -->
        <div class="readonly-info-section">
          <div class="readonly-item">
            <span class="readonly-label">{{ 'Name' | translate }}</span>
            <span class="readonly-value">{{ selectedImageForTags?.name || ('Satellite image' | translate) }}</span>
          </div>
          <div class="readonly-item" *ngIf="selectedImageForTags?.areas?.length">
            <span class="readonly-label">{{ 'District' | translate }}</span>
            <span class="readonly-value">{{ getRegionNamesByIds(selectedImageForTags.areas).join(', ') }}</span>
          </div>
        </div>

        <!-- Секция редактирования настроек снимка -->
          <div class="image-settings-section">
          <h4>{{ 'SATELLITE_IMAGES.EDIT_MODAL.SETTINGS_TITLE' | translate }}</h4>
          <div class="settings-form">
            <div class="form-group">
              <app-checkbox
                [(ngModel)]="editingImageIsPublic"
                [label]="'Public'"
                [size]="'medium'"
                [color]="'primary'">
              </app-checkbox>
            </div>
          </div>
        </div>

        <!-- Редактирование тегов через общий компонент tag-selector -->
        <div class="add-tag-section">
          <app-tag-selector
            [selectedTagIds]="editingTagIds"
            [label]="'UPLOAD_IMAGES.MODAL_TAGS'"
            [placeholder]="'UPLOAD_IMAGES.MODAL_TAGS_PLACEHOLDER'"
            [allowCreate]="true"
            (selectedTagIdsChange)="onEditingTagIdsChange($event)"
          ></app-tag-selector>
        </div>

        <!-- Кнопки действий -->
        <div class="modal-actions">
          <button
            class="btn btn-secondary"
            (click)="closeTagModal()"
            [disabled]="savingImageChanges">
            {{ 'Отменить' | translate }}
          </button>
          <button
            class="btn btn-primary"
            (click)="saveImageChanges()"
            [disabled]="savingImageChanges">
            <span *ngIf="savingImageChanges" class="loading-spinner"></span>
            {{ savingImageChanges ? ('Сохранение...' | translate) : ('Сохранить' | translate) }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Confirmation Modal -->
  <div class="modal-overlay" *ngIf="showDeleteConfirmation" (click)="cancelDelete()">
    <div class="modal-content delete-confirmation-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'SATELLITE_IMAGES.DELETE_MODAL.TITLE' | translate }}</h3>
        <button class="close-btn" (click)="cancelDelete()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="confirmation-content">
          <div class="warning-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <path d="M24 4L44 40H4L24 4Z" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M24 16V24M24 32H24.01" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="confirmation-text">
            <p class="confirmation-question">{{ 'Вы уверены, что хотите удалить тег' | translate }}</p>
            <p class="tag-name-to-delete">"{{ tagToDelete?.name }}"</p>
            <p class="confirmation-subtext">{{ 'Это действие нельзя отменить' | translate }}</p>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn-cancel" (click)="cancelDelete()">
            {{ 'Отмена' | translate }}
          </button>
          <button class="btn-confirm-delete" (click)="confirmDeleteTag()">
            {{ 'Удалить' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Modal (просмотр информации о снимке) -->
  <div class="modal-overlay" *ngIf="showInfoModal" (click)="closeInfoModal()">
    <div class="modal-content info-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'SATELLITE_IMAGES.INFO_MODAL.TITLE' | translate }}</h3>
        <button class="close-btn" (click)="closeInfoModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="info-modal-layout" *ngIf="!infoModalLoading; else infoLoadingTpl">
          <div class="info-image-section">
            <div class="info-image-wrapper">
              <img
                [src]="infoModalPreviewUrl || infoModalImage?.thumbnail || 'assets/icons/main/light/Group 6.svg'"
                [alt]="infoModalImage?.name || 'Satellite Image'">
            </div>
          </div>

          <div class="info-details-section">
            <div class="preview-meta">
              <!-- Название (нередактируемое) -->
              <div class="meta-item">
                <span class="meta-label">{{ 'Name' | translate }}</span>
                <span class="meta-value readonly">{{ infoModalImage?.name || ('Satellite image' | translate) }}</span>
              </div>

              <!-- Область/Регион (нередактируемое) -->
              <div class="meta-item" *ngIf="infoModalImage?.areas?.length">
                <span class="meta-label">{{ 'District' | translate }}</span>
                <span class="meta-value readonly">
                  {{ getRegionNamesByIds(infoModalImage.areas).join(', ') }}
                </span>
              </div>

              <div class="meta-item">
                <span class="meta-label">{{ 'Satellite' | translate }}</span>
                <span class="meta-value">{{ infoModalImage?.mission }} ({{ infoModalImage?.instrument }})</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">{{ 'Sensing time' | translate }}</span>
                <span class="meta-value">{{ infoModalImage?.originDate | date:'dd.MM.yy HH:mm' }}</span>
              </div>
              <div class="meta-item" *ngIf="infoModalImage?.center">
                <span class="meta-label">{{ 'Coordinates' | translate }}</span>
                <span class="meta-value">
                  {{ infoModalImage.center.latitude | number:'1.4-4' }},
                  {{ infoModalImage.center.longitude | number:'1.4-4' }}
                </span>
              </div>
              <div class="meta-item" *ngIf="infoModalImage?.size">
                <span class="meta-label">{{ 'Size' | translate }}</span>
                <span class="meta-value">{{ infoModalImage.size }} {{ infoModalImage.unit }}</span>
              </div>
              <!-- Дата загрузки -->
              <div class="meta-item" *ngIf="infoModalImage?.createAt">
                <span class="meta-label">{{ 'Upload Date' | translate }}</span>
                <span class="meta-value">
                  {{
                     infoModalImage?.createAt | date:'dd.MM.yy HH:mm'
                  }}
                </span>
              </div>
            </div>

            <!-- Краткие Inspire-метаданные -->
            <div class="preview-meta" *ngIf="infoModalInspireMetadata">
              <div class="meta-item">
                <span class="meta-label">{{ 'Provider' | translate }}</span>
                <span class="meta-value">
                  {{ infoModalInspireMetadata?.organisationName || infoModalInspireMetadata?.OrganisationName }}
                </span>
              </div>
              <div class="meta-item" *ngIf="infoModalInspireMetadata?.email || infoModalInspireMetadata?.Email">
                <span class="meta-label">{{ 'Email' | translate }}</span>
                <span class="meta-value">
                  {{ infoModalInspireMetadata?.email || infoModalInspireMetadata?.Email }}
                </span>
              </div>
              <div class="meta-item">
                <span class="meta-label">{{ 'Reference system' | translate }}</span>
                <span class="meta-value">
                  {{ infoModalInspireMetadata?.referenceSystemCode || infoModalInspireMetadata?.ReferenceSystemCode }}
                </span>
              </div>
            </div>

            <!-- Теги бейджами -->
            <div class="preview-tags" *ngIf="infoModalImage?.tags?.length">
              <div class="tags-section">
                <span class="meta-label">{{ 'Tags' | translate }}</span>
                <div class="tags-badges">
                  <span class="tag-badge" *ngFor="let tag of infoModalImage.tags">
                    {{ tag.name }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Дропдаун выбора индекса -->
            <!-- Выбор индекса теперь через встроенный компонент карты (DatePicker + MsfSelect в левом нижнем углу) -->

            <!-- Доступные слои бейджами (для информации) -->
            <div class="preview-layers" *ngIf="availableIndices && availableIndices.length > 0">
              <div class="layers-section">
                <span class="meta-label">{{ 'Available layers' | translate }}</span>
                <div class="layers-badges">
                  <span class="layer-badge" *ngFor="let indexKey of availableIndices">
                    {{ getIndexLabel(indexKey) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #infoLoadingTpl>
          <div class="loading-content">
            <div class="spinner"></div>
            <p>{{ 'Загрузка информации о снимке...' | translate }}</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <app-geo-image-upload-modal
    [visible]="showGeoImageUploadModal"
    (visibleChange)="showGeoImageUploadModal = $event"
    (cancel)="showGeoImageUploadModal = false"
    (uploaded)="onGeoImagesUploaded()">
  </app-geo-image-upload-modal>

  <app-upload-request-modal
    [(isOpen)]="showUploadModal"
    [regionTree]="regionTree"
    [getLocalizedRegionName]="getLocalizedRegionName.bind(this)"
    [getAllRegionsLabel]="getAllRegionsLabel.bind(this)"
    (submit)="onUploadSubmit()">
  </app-upload-request-modal>

  <!-- Download Modal with Progress -->
  <div class="modal-overlay" *ngIf="showDownloadModal" (click)="closeDownloadModal()">
    <div class="modal-content download-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'Downloading' | translate }}</h3>
        <button class="close-btn" (click)="closeDownloadModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="download-progress-container">
          <div class="progress-info">
            <p>{{ 'Downloading file' | translate }}: {{ downloadingFileName }}</p>
            <app-download-progress
              [downloadProgress]="downloadProgress"
            ></app-download-progress>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Toast для уведомлений -->
  <p-toast></p-toast>
</div>
